module.exports = __webpack_public_path__ + "img/x8.f4bc61c3.jpg";